/**
 * @generated SignedSource<<7c0de3e559c93fe948eb42a0f021abbd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type blockingIssue_periscope_BlockingIssueTask$data = {
  readonly __typename: "WorkSuggestionsBlockingIssueTask";
  readonly blockedIssues: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"blockedIssue_periscope_BlockedIssuesPanel">;
  }> | null | undefined;
  readonly id: string;
  readonly issueIconUrl: string;
  readonly issueKey: string;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "blockingIssue_periscope_BlockingIssueTask";
};
export type blockingIssue_periscope_BlockingIssueTask$key = {
  readonly " $data"?: blockingIssue_periscope_BlockingIssueTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"blockingIssue_periscope_BlockingIssueTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "blockingIssue_periscope_BlockingIssueTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "issueKey"
    },
    {
      "kind": "ScalarField",
      "name": "issueIconUrl"
    },
    {
      "concreteType": "WorkSuggestionsBlockedIssue",
      "kind": "LinkedField",
      "name": "blockedIssues",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "blockedIssue_periscope_BlockedIssuesPanel"
        }
      ]
    }
  ],
  "type": "WorkSuggestionsBlockingIssueTask"
};

(node as any).hash = "6fabbd8040ed77ff5731ea3f32535ac4";

export default node;
